import React from 'react';
import { parse12h, format12h } from '../lib/format';

// Explicit AM/PM picker — critical for bridal call times
export default function AmPmTimePicker({ value, onChange, label, testId = 'time' }) {
  const parsed = parse12h(value);
  const setPart = (part, val) => {
    const next = { ...parsed, [part]: val };
    onChange(format12h(next));
  };
  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const mins = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
  return (
    <div>
      {label && <label className="eyebrow block mb-1">{label}</label>}
      <div className="flex gap-2 items-center">
        <select value={parsed.h || ''} onChange={e => setPart('h', parseInt(e.target.value))} data-testid={`${testId}-hour`} className="w-20">
          <option value="">HH</option>
          {hours.map(h => <option key={h} value={h}>{String(h).padStart(2,'0')}</option>)}
        </select>
        <span className="text-[var(--muted)]">:</span>
        <select value={parsed.m === '' ? '' : String(parsed.m).padStart(2,'0')} onChange={e => setPart('m', parseInt(e.target.value))} data-testid={`${testId}-min`} className="w-20">
          <option value="">MM</option>
          {mins.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <div className="flex" role="tablist" aria-label="AM or PM">
          <button type="button" onClick={() => setPart('ampm','AM')} data-testid={`${testId}-am`}
            className="px-3 py-2 text-xs border rounded-l-full min-h-[44px]"
            style={{background: parsed.ampm==='AM'?'var(--charcoal)':'transparent', color: parsed.ampm==='AM'?'var(--cream)':'var(--charcoal)', borderColor:'var(--line)'}}>
            AM
          </button>
          <button type="button" onClick={() => setPart('ampm','PM')} data-testid={`${testId}-pm`}
            className="px-3 py-2 text-xs border-t border-b border-r rounded-r-full min-h-[44px]"
            style={{background: parsed.ampm==='PM'?'var(--charcoal)':'transparent', color: parsed.ampm==='PM'?'var(--cream)':'var(--charcoal)', borderColor:'var(--line)'}}>
            PM
          </button>
        </div>
      </div>
    </div>
  );
}
